<template>
  <page-status class="proposal-sign">
    <div class="header">
      <span>请投保人</span>
      <span class="active">{{ userName }}</span>
      <span>在输入框中签字</span>
    </div>

    <div class="notice">请用正楷签名，每次只需要签一个字</div>

    <div class="sign-container">
      <canvas
        style="background: #ffffff"
        ref="canvas"
        width="200"
        height="200"
      ></canvas>
      <div class="sign-content">
        <canvas
          ref="canvasBackground"
          style="width: 90vw; height: 90vw"
        ></canvas>
        <vue-signature-pad
          style="position: relative; top: -90vw"
          width="100%"
          height="100%"
          ref="signaturePad"
          :options="{ onEnd, minWidth: 1, maxWidth: 5 }"
        />
      </div>
    </div>

    <div class="sign-result">
      <div class="result-title">已输入文字</div>
      <div class="images">
        <img v-for="(item, index) in images" :key="index" :src="item" alt="" />
      </div>
    </div>

    <div class="sign-actions">
      <van-button class="button" type="default" @click="fetchData()">
        重签
      </van-button>
      <van-button class="button" type="info" @click="onConfirmSignature()">
        提交
      </van-button>
    </div>
  </page-status>
</template>

<script>
import { Toast, Dialog } from 'vant';
import VueSignaturePad from 'vue-signature-pad';
import PageStatus from '@/components/PageStatus';
import * as services from '@/services';

export default {
  name: 'AuthSignature',
  components: {
    VueSignaturePad,
    PageStatus,
  },

  data() {
    return {
      images: [],
      userName: '',
    };
  },

  computed: {
    unreadItem() {
      return this.detail.clauseVos.find(item => !item.clicked);
    },
  },

  watch: {
    checked(newValue) {
      if (this.unreadItem && newValue) {
        this.showDialog = true;
        this.checked = false;
      }
    },
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },

  activated() {
    this.$refs.signaturePad && this.$refs.signaturePad.resizeCanvas();
    this.$refs.canvasBackground && this.$refs.canvasBackground.resizeCanvas();
  },

  methods: {
    drawText(fileIndex) {
      const canvas = this.$refs.canvasBackground;
      const ctx = canvas.getContext('2d');
      const text = this.userName[fileIndex];
      ctx.fillStyle = '#ffffff';
      const width = canvas.width;
      const height = canvas.height;
      ctx.fillRect(0, 0, width, height);
      const img = new Image();
      img.src =
        'https://i3.cathay-ins.com.cn/prod/posts/e73e20dd1ecd6cd05f0bdab1fd75e78e.png';
      img.onload = () => {
        ctx.drawImage(img, 0, 0, width, height);
        ctx.font = '150px Georgia,serif';
        ctx.fontWeight = 'bold';
        ctx.fillStyle = '#ddd';
        if (text) {
          ctx.fillText(text, 80, 130);
        }
      };
    },
    onEnd() {
      this.t && clearTimeout(this.t);

      this.t = setTimeout(() => {
        const signaturePad = this.$refs.signaturePad;
        const { isEmpty, data } = signaturePad.saveSignature();

        if (!isEmpty) {
          this.setImgBg(data).then(dataUrl => {
            this.discernSigned(dataUrl);
          });
        }
      }, 2000);
    },

    setImgBg(data) {
      return new Promise(resolve => {
        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, 200, 200);
        const img = new Image();
        img.src = data;
        img.onload = () => {
          ctx.drawImage(img, 0, 0, 200, 200);
          const dataUrl = canvas.toDataURL('image/jpeg');
          resolve(dataUrl);
        };
      });
    },

    discernSigned(data) {
      Toast.loading({
        message: '正在验证...',
        forbidClick: true,
        duration: 0,
      });

      const file = this.dataURLtoFile(data);
      const fileIndex = this.images.length;
      const { businessNo, mobile } = this.$route.query;

      services
        .discernSignedInsure(businessNo, mobile, file, fileIndex)
        .then(res => {
          if (res.data) {
            this.images.push(data);
            this.onClearSignature();
            this.drawText(fileIndex + 1);
          } else {
            Dialog.alert({
              message: '签名内容非投保人姓名，请使用正楷字体重新签署。',
            }).then(() => {
              this.onClearSignature();
            });
          }
          Toast.clear();
        });
    },

    onClearSignature() {
      this.$refs.signaturePad.clearSignature();
    },

    fetchData() {
      const { businessNo } = this.$route.query;

      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });

      services.getSignedInit(businessNo).then(res => {
        this.userName = res.data;
        this.drawText(0);
        this.$refs.signaturePad && this.$refs.signaturePad.clearSignature();
        this.images = [];
        Toast.clear();
      });
    },

    dataURLtoFile(dataURL) {
      const parts = dataURL.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; i++) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      const filename = `${Date.now()}.png`;
      const blob = new Blob([uInt8Array], { type: contentType });
      return new File([blob], filename, { type: contentType });
    },

    onConfirmSignature() {
      const { businessNo, mobile, realAuthSmsFlag } = this.$route.query;
      services
        .uploadSignedInsure(businessNo)
        .then(res => {
          if (res.head.returnCode === '0') {
            services.authShift(businessNo).then(res => {
              const { content } = res;
              const { signUrl, signStatus } = JSON.parse(content);
              if (signStatus === '1') {
                const token =
                  this.$route.query.authToken ||
                  window.localStorage.getItem('authToken');
                const newUrl = token
                  ? `${signUrl}&authToken=${token}`
                  : signUrl;
                window.location.href = newUrl;
              }
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less">
.proposal-sign {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 94px;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #fff;

  .header {
    height: 48px;
    line-height: 48px;
    background-color: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(48, 49, 51, 0.1);
    text-align: center;
    color: #434b65;
    font-size: 16px;
    .active {
      color: #ad3b1b;
      margin: 0 4px;
    }
  }

  .notice {
    height: 38px;
    line-height: 38px;
    background-color: #fff9ed;
    text-align: center;
    font-size: 14px;
    color: #ff6010;
    border-top: solid 1px #eeeeee;
  }

  .sign-container {
    width: 92vw;
    height: 92vw;
    margin: 4vw;
    position: relative;
  }
  /*background-image: url('https://i3.cathay-ins.com.cn/prod/posts/e73e20dd1ecd6cd05f0bdab1fd75e78e.png');
    border: 1px solid #dcdcdc;
  */
  .sign-content {
    width: 92vw;
    height: 92vw;
    background-size: contain;
    background-repeat: no-repeat;
    border-radius: 4px;
    margin: 0 auto;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
  }

  .sign-actions {
    padding: 16px 16px 30px;
    display: flex;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-top: solid 1px #eeeeee;

    .button {
      flex: 1;
    }

    .button + .button {
      margin-left: 12px;
    }
  }

  .sign-result {
    display: flex;
    flex-direction: column;
    text-align: center;
    .result-title {
      font-size: 14px;
      color: #808897;
      margin-bottom: 10px;
    }
    .images {
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
